var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"data-track-action":"click_button","data-track-label":"reply_comment_button","category":"tertiary","icon":"reply","title":_vm.$options.i18n.buttonText,"aria-label":_vm.$options.i18n.buttonText},on:{"click":function($event){return _vm.$emit('startReplying')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }